export default function () {
  $('#account_client').change(function() {
    toggleInvoiceIndex($(this));
  });

  var toggleInvoiceIndex = function(checkbox) {
    var invoiceIndex = $('#account_invoiceIndex');

    if (!checkbox.is(':checked')) {
      invoiceIndex.attr('disabled', true);
      invoiceIndex.data('oldVal', invoiceIndex.val());
      invoiceIndex.val('');
    } else {
      invoiceIndex.attr('disabled', false);
      var oldVal = invoiceIndex.data('oldVal');
      if (oldVal) {
        invoiceIndex.val(oldVal);
      }
    }
  };

  toggleInvoiceIndex($('#account_client'));
};



// WEBPACK FOOTER //
// ./assets/js/account-edit.js